export default class DateTimeParser {
    static parseTimeHHMMSS(time) {
        const [hours, minutes, seconds] = time.split(':');

        if(hours === undefined || minutes === undefined || seconds === undefined) {
            throw new Error('Can\'t parse time: ' + time);
        }

        const currentDate = new Date();
        const parsedDate = new Date(
            currentDate.getFullYear(),
            currentDate.getMonth(),
            currentDate.getDate(),
            hours,
            minutes,
            seconds
        );

        return Math.floor(parsedDate.getTime() / 1000);
    }
}
